<script setup>
import { computed } from 'vue';
import { THEMES } from '@/constants';
import { usePage } from '@inertiajs/vue3';

const page = usePage();
const context = computed(() => page.props?.context);
const theme = context.value.theme;

const input = defineModel({type: String});

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    default: '',
  },
  autocomplete: {
    type: String,
    default: 'off',
  },
  label: {
    type: String,
    required: true,
  },
  hideLabel: {
    type: Boolean,
    default: false,
  },
  validation: {
    type: Object,
    default: {},
  },
});

const textAreaClasses = computed(() => [
  'py-2 px-3 w-full block border border-solid rounded-3xl',
  theme == THEMES.STUDY_AUS && 'border-primary-500 text-primary-900',
]);
</script>

<template>
  <div>
    <label
      :for="name"
      :class="{'sr-only': hideLabel}"
      class="text-xs font-semibold"
    >{{ label }}</label>
    <textarea
      :id="name"
      v-model="input"
      :class="[textAreaClasses, validation.$error ? 'ring-1 ring-red' : 'bg-white']"
      :autocomplete="autocomplete"
      type="text"
      :name="name"
      :placeholder="placeholder"
    />
    <div
      v-if="validation.$error"
      class="text-red text-sm"
    >
      {{ validation.$errors[0].$message }}
    </div>
  </div>
</template>